import React from 'react';

import {
    getPageLayoutOptions,
    type PageLayoutOptions,
    type RevisionPageDocument,
} from '@gitbook/hive-core';

/**
 * Hook to get the page layout options of the given page.
 */
export function usePageLayoutOptions(page: RevisionPageDocument | null): PageLayoutOptions {
    return React.useMemo(() => getPageLayoutOptions(page), [page]);
}
